import { Spinner, Switch } from '@mgh-app/component-library';
import { FormControlLabel, FormGroup } from '@mui/material';
import { MainLayoutContext } from 'layouts/MainLayout';
import { useAppNavigation } from 'navigation/useAppNavigation';
import { useContext, useEffect, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { useGetAwayModeQuery, useSetAwayModeMutation } from 'services/ThingsService';
import { display, justifyItems, margin, twCls } from 'style';

export const HomeSettings = () => {
  const { setTitle, showNavigationButtons, navigateBackAction } = useContext(MainLayoutContext);
  const [awayMode, setAwayMode] = useState(false);
  const {
    data: away,
    refetch: refetchAwayMode,
    isLoading: isLoadingAwayMode,
  } = useGetAwayModeQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [updateAway] = useSetAwayModeMutation();
  const { navigateBack, navigateHome } = useAppNavigation();

  useEffectOnce(() => {
    setTitle('Home Settings');
    showNavigationButtons(true);
    navigateBackAction(() => navigateHome);
    return () => navigateBackAction(() => navigateBack);
  });

  useEffect(() => {
    setAwayMode(away?.mode === 'ON');
  }, [away?.mode, setAwayMode]);

  const onAwayModeToggle = async () => {
    setAwayMode(!awayMode);
    await updateAway({ ...(away || {}), mode: away?.mode === 'ON' ? 'OFF' : 'ON' });
    await refetchAwayMode();
  };

  return (
    <div className={twCls(margin('mt-17'), display('grid'), justifyItems('justify-items-center'))}>
      {isLoadingAwayMode ? (
        <Spinner />
      ) : (
        <FormGroup>
          <FormControlLabel
            control={
              <Switch name="awayModeSwitch" checked={awayMode} onChange={onAwayModeToggle} />
            }
            label="Away Mode"
          />
        </FormGroup>
      )}
    </div>
  );
};
